import React, { Component } from 'react';
import { Input, Button, Spin, Popover } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import './cloudShare.scss';
import { store } from 'Store/store.index';
import { inject, observer } from 'mobx-react';
import { collaborationMqttService } from 'Store/services/index';

@inject('appStore', 'userStore', 'accountStore', 'historyStore')
@observer
class CloudShare extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectMenu: 'Home',
      drawCode: '',
    };
  }
  componentDidMount() {}
  login = () => {
    store.loginNewStore.login();
    if (!store.shareCollaborationStore.isLoginInterval) {
      store.shareCollaborationStore.setIsLoginInterval(true);
      let isLogin = setInterval(() => {
        if (store.loginNewStore.isLogin && store.userNewStore.userData.userId) {
          // 登录成功
          clearInterval(isLogin);
          window.location.reload();
          // store.shareCollaborationStore.setIsLoginInterval(false)
          // store.shareCollaborationStore.joinShare()
        }
      }, 500);
    }
  };
  onChange = (e) => {
    this.setState({ drawCode: e.target.value });
  };
  checkSharePwdShare = async () => {
    const { drawCode } = this.state;
    let result = await store.shareCollaborationStore.checkSharePwdShare(drawCode);
    if (result && result.code === 0) {
      // store.collaborationStore.openCPDFTocllaborationMode();
      // 打开文档,关闭当前页面
      if (result.data) {
        this.setState({
          drawCodeErr: '',
        });
        // 显示loading，
        store.shareCollaborationStore.setCloudShareType('showLoading');
        // 打开文档
        store.shareCollaborationStore.downloadURLAndOpenFile();
        let userData = store.userNewStore.userData;
        let result2 = await store.shareCollaborationStore.addCollaboratorUser(userData, true);
        if (result2 && result2.code === 0) {
          setTimeout(() => {
            collaborationMqttService.publish('addCollaboratorUser'); // 触发mqtt通信
          }, 4000);
        }
      } else {
        this.setState({
          drawCodeErr: '请填写正确的提取码',
        });
      }
    }
  };
  clickPCBtn = () => {
    window.open('https://file.foxitreader.cn/file/Channel/foxityunbangongweb/nnybgldy_FoxitCloud_Full.exe');
  };

  render() {
    const { cloudShareType } = store.shareCollaborationStore;
    const { drawCode, drawCodeErr } = this.state;
    const antIcon = <LoadingOutlined style={{ fontSize: 40, color: '#753273' }} spin />;
    const content = (
      <div className="popoverQrCode">
        <img src={require('@/assets/fw_cloud_editor/img_downAppQRCode.png')} alt="AppQRCode" />
        <p>扫一扫，立即下载</p>
      </div>
    );
    console.log(cloudShareType);
    return (
      <React.Fragment>
        <div className="cloudShareBox">
          {
            // 未登录
            cloudShareType === 'showLogin' && (
              <div className="shareDrawCodeBox">
                <div className="shareLayerBox drawCodeLayerBox loginLayerBox">
                  <img src={require('@/assets/fw_cloud_editor/img_shareFile_new.png')} alt="文件"></img>
                  <h4>{store.shareCollaborationStore.shareInfo.fileName}</h4>
                  <p>您还未登录账号</p>
                  <Button onClick={this.login} type="primary">
                    立即登录
                  </Button>
                  <div className="downAppBox">
                    <h4>
                      下载 <span>福昕云办公客户端</span> 阅读文档体验更好哦
                    </h4>
                    <div className="downAppList">
                      <div className="downAppItem pc" onClick={this.clickPCBtn}>
                        <span></span>
                        <p>电脑版</p>
                      </div>
                      <Popover placement="bottom" title="" content={content}>
                        <div className="downAppItem mobile">
                          <span></span>
                          <p>手机版</p>
                        </div>
                      </Popover>
                    </div>
                  </div>
                </div>
                <p className="thisNumberBox copyrightInformation">
                  ©2026 福建福昕软件开发股份有限公司 版权所有 
                  <a target="_blank" rel="noopener noreferrer" href="https://beian.miit.gov.cn">
                    闽ICP备13015634号
                  </a>
                  ·
                  <a target="_blank" rel="noopener noreferrer" href="https://myd.pdf365.cn/agreement/foxitprivacy.html">
                    隐私策略
                  </a>
                </p>
              </div>
            )
          }
          {
            // 无权限
            cloudShareType === 'showNoAuth' && (
              <div className="shareDrawCodeBox">
                <div className="shareLayerBox drawCodeLayerBox noAuthLayerBox">
                  <img src={require('@/assets/fw_cloud_editor/img_noShareAuth.png')} alt="logo"></img>
                  <p>没有访问权限</p>
                  <h6>作者已设置指定人访问</h6>
                  <h6>当前登录账号 {store.userNewStore.userData.nickname}</h6>
                </div>
                <p className="thisNumberBox copyrightInformation">
                  ©2026 福建福昕软件开发股份有限公司 版权所有 
                  <a target="_blank" rel="noopener noreferrer" href="https://beian.miit.gov.cn">
                    闽ICP备13015634号
                  </a>
                  ·
                  <a target="_blank" rel="noopener noreferrer" href="https://myd.pdf365.cn/agreement/foxitprivacy.html">
                    隐私策略
                  </a>
                </p>
              </div>
            )
          }
          {
            // 取消分享
            cloudShareType === 'showNoShare' && (
              <div className="shareDrawCodeBox">
                <div className="shareLayerBox noShareLayerBox">
                  <img src={require('@/assets/fw_cloud_editor/img_noShareAuth.png')} alt="logo"></img>
                  <p>文档所有者取消了访问文档权限</p>
                </div>
              </div>
            )
          }
          {
            // 验证分享密码
            cloudShareType === 'showCheckDrawCode' && (
              <div className="shareDrawCodeBox">
                <div className="shareLayerBox drawCodeLayerBox">
                  <img src={require('@/assets/fw_cloud_editor/img_logo1.png')} alt="logo"></img>
                  <p>请输入提取码: </p>
                  <Input maxLength={4} placeholder="请输入4位新密码，限数字与字母组合" value={drawCode} onChange={this.onChange} />
                  <h5 className="drawCodeErr"> {drawCodeErr}</h5>
                  <Button onClick={this.checkSharePwdShare}>确定</Button>
                </div>
                <p className="thisNumberBox copyrightInformation">
                  ©2026 福建福昕软件开发股份有限公司 版权所有 
                  <a target="_blank" rel="noopener noreferrer" href="https://beian.miit.gov.cn">
                    闽ICP备13015634号
                  </a>
                  ·
                  <a target="_blank" rel="noopener noreferrer" href="https://myd.pdf365.cn/agreement/foxitprivacy.html">
                    隐私策略
                  </a>
                </p>
              </div>
            )
          }
          {
            // 验证分享密码
            cloudShareType === 'showLoading' && (
              <div className="shareDrawCodeBox">
                <div className="shareLayerBox drawCodeLayerBox loadingLayer">
                  <img src={require('@/assets/fw_cloud_editor/img_logo1.png')} alt="logo"></img>
                  <p>多人在线协作文档</p>
                  <Spin indicator={antIcon} />
                </div>
                <p className="thisNumberBox copyrightInformation">
                  ©2026 福建福昕软件开发股份有限公司 版权所有 
                  <a target="_blank" rel="noopener noreferrer" href="https://beian.miit.gov.cn">
                    闽ICP备13015634号
                  </a>
                  ·
                  <a target="_blank" rel="noopener noreferrer" href="https://myd.pdf365.cn/agreement/foxitprivacy.html">
                    隐私策略
                  </a>
                </p>
              </div>
            )
          }
        </div>
      </React.Fragment>
    );
  }
}
export default CloudShare;
